import React, { useEffect, useState } from "react"
import axios from "axios"
import { useDispatch } from "react-redux"
import { attemptLogin } from "../store"
import { Link, useNavigate } from "react-router-dom"
import { emailValidator, passwordValidator, usernameValidator } from "../util"
import { UserIcon, MailIcon, LockKeyholeIcon } from "lucide-react"
import CreateAccountImg from "../assets/createAccountImg.jpg"
import "./styles/CreateAccount.css"

const CreateAccount = () => {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [email, setEmail] = useState("")
  const [isValidUsername, setIsValidUsername] = useState(true)
  const [isValidPassword, setIsValidPassword] = useState(true)
  const [isValidEmail, setIsValidEmail] = useState(true)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  // Helper function to generate label spans
  const createLabelSpans = (word) => {
    return [...word].map((letter, index) => (
      <span key={index} style={{ transitionDelay: `${index * 50}ms` }}>
        {letter}
      </span>
    ))
  }

  useEffect(() => {
    setIsValidUsername(username ? usernameValidator(username) : true)
  }, [username])

  useEffect(() => {
    setIsValidPassword(password ? passwordValidator(password) : true)
  }, [password])

  useEffect(() => {
    setIsValidEmail(email ? emailValidator(email) : true)
  }, [email])

  const createAccount = async (event) => {
    event.preventDefault()
    if (isValidUsername && isValidPassword && isValidEmail) {
      const newUser = { username, password, email }
      try {
        await axios.post("/api/account/create", newUser)
        dispatch(attemptLogin({ username, password }))
        navigate("/")
      } catch (error) {
        if (error.response && error.response.status === 403) {
          window.alert(error.response.data)
        } else {
          console.error(error)
        }
      }
    }
  }

  return (
    <div className="signup-page-layout">
      <form className="signup-form" onSubmit={createAccount}>
        <h2 className="signup-title">Sign Up</h2>
        <div className="form-group-container">
          {/* Username Field */}
          <UserIcon size={30} className="form-icons" />
          <div className="form-group-form-control">
            <input
              type="text"
              id="username"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className={`form-input ${
                !isValidUsername ? "input-invalid" : ""
              }`}
            />
            <label htmlFor="username" className="form-label">
              {createLabelSpans("Username")}
            </label>
          </div>
          {!isValidUsername && username && (
            <span className="error-message">
              Must start with a letter and can include alphanumeric characters
              and underscores between 8 to 30 characters long.
            </span>
          )}
          {/* Email Field */}
          <MailIcon size={30} className="form-icons" />
          <div className="form-group-form-control">
            <input
              type="email"
              id="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`form-input ${!isValidEmail ? "input-invalid" : ""}`}
            />
            <label htmlFor="email" className="form-label">
              {createLabelSpans("Email")}
            </label>
          </div>
          {!isValidEmail && email && (
            <span className="error-message">
              Must follow standard email format.
            </span>
          )}
          {/* Password Field */}
          <LockKeyholeIcon size={30} className="form-icons" />
          <div className="form-group-form-control">
            <input
              type="password"
              id="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`form-input ${
                !isValidPassword ? "input-invalid" : ""
              }`}
            />

            <label htmlFor="password" className="form-label">
              {createLabelSpans("Password")}
            </label>
          </div>
          {!isValidPassword && password && (
            <span className="error-message">
              Must start with a letter and can include alphanumeric characters
              and underscores between 8 to 15 characters long.
            </span>
          )}
        </div>

        <button
          type="submit"
          disabled={!isValidUsername || !isValidPassword || !isValidEmail}
          className="btn-register"
        >
          Create Account
        </button>
      </form>

      <div className="signup-right-column">
        <img
          src={CreateAccountImg}
          alt="Man on Ladder Installing Gutter on House"
          className="signup-logo"
        />
        <Link to="/login" className="login-link-redirect">
          Have An Account? Sign In Here
        </Link>
      </div>
    </div>
  )
}

export default CreateAccount
